var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8852 3.85177C13.3346 4.52437 13.3346 5.46068 13.3346 7.33329C13.3346 9.20591 13.3346 10.1422 12.8852 10.8148C12.6907 11.106 12.4407 11.356 12.1495 11.5505C11.5619 11.9431 10.7731 11.9928 9.33464 11.9991V12L8.59759 13.4741C8.3519 13.9654 7.6507 13.9654 7.40502 13.4741L6.66797 12V11.9991C5.2295 11.9928 4.44068 11.9431 3.85311 11.5505C3.56194 11.356 3.31194 11.106 3.11738 10.8148C2.66797 10.1422 2.66797 9.20591 2.66797 7.33329C2.66797 5.46068 2.66797 4.52437 3.11738 3.85177C3.31194 3.5606 3.56194 3.3106 3.85311 3.11604C4.52571 2.66663 5.46202 2.66663 7.33464 2.66663H8.66797C10.5406 2.66663 11.4769 2.66663 12.1495 3.11604C12.4407 3.3106 12.6907 3.5606 12.8852 3.85177Z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6L10 6",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.66663H8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMessage);
export default __webpack_public_path__ + "static/media/error_message.2e7f041867dbd8efadd2e32b21c9f9ab.svg";
export { ForwardRef as ReactComponent };